import { PublicClientApplication, Configuration } from "@azure/msal-browser";
import { getAuthConfig } from "./authConfig";

let client: PublicClientApplication | undefined;
const instance = () => {
  const configProvider = getAuthConfig();
  const config: Configuration = {
    auth: {
      clientId: configProvider.MSAL_CLIENT_ID,
      redirectUri: configProvider.MSAL_LOGIN_REDIRECT,
      authority: configProvider.MSAL_AUTHORITY,
    },
    cache: {
      cacheLocation: "localStorage", // Use localStorage instead of sessionStorage to share auth across tabs
      storeAuthStateInCookie: false,
    },
  };
  if (!client) {
    client = new PublicClientApplication(config);
  }
  return client;
};

const publicClientApplication = {
  instance,
};

export default publicClientApplication;
